module.exports = __webpack_public_path__ + "static/image-0463945ad2cdc6cd661cffa69d31be76.jpg";